export default "__VITE_ASSET__DfdJNyzV__"